<template>
	<div class=" footer">
    <div class="pd-t50 pd-b30">
      <div class="clear pd-l80 pd-r60 footer-box">
        <div class="fl w500 pos-relative footer-left-box">
          <div class="mg-b20">
            <img class="footer-logo" :src="publicPath + 'static/images/common/logo_white.png'" alt="logo">
          </div>

          <div class="clear">

            <div class="fl mg-r30 footer-contact-info">
              <div class="color-white h30 lh30 mg-b10 footer-contact-info-item">
                电话：010-87878876
              </div>

              <div class="color-white h30 lh30 mg-b10 footer-contact-info-item">
                邮箱：hede@hedejj.com
              </div>

              <div class="color-white h30 lh30 footer-contact-info-item">
                地址：北京市丰台区丽泽路16号院4号楼8层801内02A单元
              </div>
            </div>



          </div>

          <div class="pos-abs t0 r0 qr-code-img">
            <img class=""
                 :src="publicPath + 'static/images/common/qr_code.jpg'"
                 alt="logo">
          </div>

          <div class="w1 h200 pos-abs pos-c-r r-50" style="background: #9c9795"></div>
        </div>
        
        
        
        <div class="fr">
          <div class="clear pos-relative submenu-cat-box-list">
            <div class="fl mg-l60 submenu-cat-box-list-item" v-for="(item, index) in subMenu">
              <div class="mg-b30 text-center submenu-cat-title">
                <div class="color-white f18">{{ item.title[0] }}</div>
                <div class="color-white f12">{{ item.title[1] }}</div>
              </div>

              <div class="submenu-cat-list">
                <div @click="goToPage(item2)"
                     class="mouse-pointer h22 lh22 mg-b10 text-center submenu-cat-list-item"
                     v-for="(item2, index2) in item.list">
                  <span class="color-white">{{ item2.name }}</span>
                </div>
              </div>
            </div>



            <div class="pos-abs b0 r20">
              <div @click="goToHotProductPage" class="mouse-pointer submenu-cat-box-list-item">
                <div class="text-center submenu-cat-title">
                  <div class="color-white f18">热门产品</div>
                  <div class="color-white f12">Hot Products</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pd-l80 pd-r80 bottom-copyright-info">

      <div class="d-flex justify-content-space-between w100p">

        <div class="color-white">
          版权所有：和德保险经纪有限公司
        </div>

        <div class="color-white">
          京ICP备：13023906号-1 号
        </div>

        <div class="color-white">
          京公网安备 11010102003467号
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: "Footer",

    data() {
      return {
        subMenu: [
          {
            title: ['首页', 'HOME'],
            list: [
              { id: 1, name: '服务目标', routerName: 'service-objectives', type: 'link' },
              { id: 2, name: '业务领域', routerName: 'market-segments', type: 'link' },
              { id: 3, name: '合作伙伴', routerName: 'contact-us', type: 'link' },
            ]
          },
          {
            title: ['公司简介', 'COMPANY'],
            list: [
              { id: 1, name: '股东介绍', routerName: 'introduction', type: 'link' },
              { id: 2, name: '公司简介', routerName: 'company', type: 'link' },
              { id: 3, name: '公司领导', routerName: 'leaders', type: 'link' },
            ]
          },
          {
            title: ['业务领域', 'BUSINESS'],
            list: [
              { id: 1, name: '核心业务板块', routerName: 'market-segments', type: 'link' },
              { id: 2, name: '细分市场', routerName: 'market-segments', type: 'link' },
              { id: 3, name: '互联网保险', routerName: 'internet-insurance', type: 'link' },
            ]
          },
          {
            title: ['服务目标和内容', 'SERVICE OBJECTIVE'],
            list: [
              { id: 1, name: '服务目标', routerName: 'service-objectives', type: 'link' },
              { id: 2, name: '服务内容', routerName: 'service-contents', type: 'link' },
            ]
          },
          {
            title: ['服务网络', 'SERVICE NETWORK'],
            list: [
              { id: 1, name: '服务网络', routerName: 'service-network', type: 'link' },
              // { id: 2, name: '热销产品', routerName: '', type: 'link' },
            ]
          }
        ],
      }
    },

    methods: {
      // 底部菜单跳转
      goToPage(item) {
        if (item.type === 'link' && this.$route.name !== item.routerName) {
          this.$router.push({
            name: item.routerName
          })
        }
      },

      goToHotProductPage() {
        // open('http://insurance.hedejj.com/home/pc#/', '_blank')
        open('https://oversea.hedejj.com', '_blank')
      }
    }
	}
</script>
